var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimize02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.99996V6.66663C10.0003 8.50758 11.4927 9.99996 13.3337 9.99996H15.0003M10.0003 4.99996C10.0003 3.15901 11.4927 1.66663 13.3337 1.66663H15.0003C16.8413 1.66663 18.3337 3.15901 18.3337 4.99996V6.66663C18.3337 8.50757 16.8413 9.99996 15.0003 9.99996M10.0003 4.99996L5.00033 4.99996C3.15938 4.99996 1.66699 6.49234 1.66699 8.33329V15C1.66699 16.8409 3.15938 18.3333 5.00033 18.3333H11.667C13.5079 18.3333 15.0003 16.8409 15.0003 15V9.99996",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 10L5.83301 14.1667L9.99967 14.1667M5.83301 14.1667L10.833 9.16669",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize02);
export default __webpack_public_path__ + "static/media/minimize-02.b6c79bdcfb1892b081e31ef45211547b.svg";
export { ForwardRef as ReactComponent };